import { render } from "./matching-card-tag-list.vue?vue&type=template&id=d76ea44c&scoped=true&ts=true"
import script from "./matching-card-tag-list.vue?vue&type=script&lang=ts"
export * from "./matching-card-tag-list.vue?vue&type=script&lang=ts"

import "./matching-card-tag-list.vue?vue&type=style&index=0&id=d76ea44c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d76ea44c"]])

export default __exports__